import { useMemo } from 'react';
import ColumnConfigurationPanel from '../ColumnConfigurationPanel.jsx';
import PresetsPanel from '../PresetsPanel.jsx';
import ValidationsPanel from '../ValidationsPanel.jsx';

const PANELS = {
  // presets: {
  //   permission: 'presets_view',
  //   id: 'presets',
  //   labelDefault: 'Presets',
  //   labelKey: 'presets',
  //   iconKey: 'columns',
  //   toolPanel: PresetsPanel
  // },
  validations: {
    permission: 'validations_view',
    id: 'validations',
    labelDefault: 'Validations',
    labelKey: 'validations',
    iconKey: 'columns',
    toolPanel: ValidationsPanel
  },
  dimensions: {
    permission: 'group', // Permission checked from context.permissions object
    id: 'columns',
    labelDefault: 'Dimensions',
    labelKey: 'columns',
    iconKey: 'menu',
    toolPanel: 'agColumnsToolPanel'
  },
  filters: {
    permission: 'group',
    id: 'filters',
    labelDefault: 'Filters',
    labelKey: 'filters',
    iconKey: 'filter',
    toolPanel: 'agFiltersToolPanel',
  },
  configure: {
    permission: 'configure',
    id: 'configure',
    labelDefault: 'Configure',
    labelKey: 'configure',
    iconKey: 'columns',
    toolPanel: ColumnConfigurationPanel,
  }
}

export default function useSidePanel({
  panels = ['presets', 'validations', 'dimensions', 'filters', 'configure'],
  defaultToolPanel = null,
  context = {},
  toolPanelParams = {}
}) {
  const sidePanel = useMemo(() => {
    let toolPanels =  {
      toolPanels: panels
        .map(p => ({...PANELS[p], toolPanelParams: toolPanelParams}))
        .filter(p => context.permissions[p.permission] && !context.excludePanels?.includes(p.id)),
      defaultToolPanel: defaultToolPanel,
    };

    return toolPanels;
  }, []);

  return sidePanel;
}